import React from 'react'
import useSWR from 'swr'

import { getClientById } from '../../api'

type Props = {
  clientId?: string
}

const InvoiceClientInfo: React.FC<Props> = ({ clientId }) => {
  const { data: client, isLoading } = useSWR(
    clientId ? `/api/clients/${clientId}` : null,
    getClientById
  )
  const [isVisible, setIsVisible] = React.useState(false)

  React.useEffect(() => {
    if (!client) return
    setIsVisible(false)
    const timer = setTimeout(() => setIsVisible(true), 150)
    return () => clearTimeout(timer)
  }, [clientId, client])

  if (!clientId) return null
  if (isLoading) return null
  if (!client) return null
  if (!client.email && !client.billingAddress) return null

  return (
    <div className='px-1 py-1 border-top'>
      <div style={{ opacity: isVisible ? 1 : 0, transition: 'opacity 180ms ease' }}>
        {client.email && <div className='fs-6 fw-light'><small>{client.email}</small></div>}
        {client.billingAddress && <div className='fs-6 fw-light'><small>{client.billingAddress}</small></div>}
      </div>
    </div>
  )
}

export default InvoiceClientInfo
